import { useState } from 'react'

import { useDecision } from '@optimizely/react-sdk'
import Loader from '@space-core/components/loader'
import {
  Actions,
  Entities,
  EventNames,
  ScreenNames,
  CommunityTypeProductConsume
} from '@space-core/datahub'
import useTranslation from '@space-core/hooks/useTranslation'
import { useForm } from '@space-shell/common/hooks/useForm'
import AccessSection from '@space-shell/modules/communities/accessAndPrivacy/components/accessSection'
import { PAGE_VIEW_ACCESS_SECTION } from '@space-shell/modules/communities/accessAndPrivacy/components/accessSection/types'
import {
  COMMUNITY_TYPE,
  COMMUNITY_TYPES_LIST
} from '@space-shell/modules/communities/accessAndPrivacy/constants'
import { useGetCreateCommunityPermission } from '@space-shell/modules/communities/hooks/useGetCreateCommunityPermission'
import { CreateCommunityPermissionFeatureName } from '@space-shell/modules/communities/hooks/useGetCreateCommunityPermission/constans'
import useSendDataHubConsume from '@space-shell/modules/communities/hooks/useSendDataHubConsume/useSendDataHubConsume'
import styled from 'styled-components'

import type { FormFields } from '../../types'

const ContainerAccessSection = styled.div`
  display: grid;
  gap: 0.75rem;
`

const Description = styled.p`
  font-size: 0.875rem;
`
const AccessAndPrivacyCommunity = () => {
  const { hasPermission, isInitialLoading } = useGetCreateCommunityPermission({
    featureName: CreateCommunityPermissionFeatureName.COMMUNITY_PUBLIC
  })

  const [selectedOption, setSelectedOption] = useState<COMMUNITY_TYPE>(COMMUNITY_TYPE.OPEN)
  const { t } = useTranslation()
  const { sendDataHubConsume } = useSendDataHubConsume()
  const { data: formData, setFormData } = useForm<FormFields>()

  const [{ enabled: isEnabledRadioButtonPaidCommunity }] = useDecision(
    'com_adm_web_enable_radio_button_paid_community'
  )
  if (isInitialLoading) {
    return (
      <div className='_mt-6'>
        <Loader full />
      </div>
    )
  }

  const CommunitiesList = COMMUNITY_TYPES_LIST({
    showPaidCommunityFlag: isEnabledRadioButtonPaidCommunity,
    showPublicCommunityFlag: hasPermission
  })
    .reverse()
    .filter((item) => item.show)

  const setCollaborativeContent = (
    communityType: COMMUNITY_TYPE,
    collaborativeContentChecked?: boolean,
    isUserClick?: boolean
  ) => {
    if (isUserClick && communityType !== COMMUNITY_TYPE.PUBLIC) return

    if (communityType === COMMUNITY_TYPE.EXCLUSIVE || communityType === COMMUNITY_TYPE.OPEN) {
      setFormData('collaborativeContent', true, isUserClick)
    }

    if (communityType === COMMUNITY_TYPE.PUBLIC && collaborativeContentChecked) {
      setFormData('collaborativeContent', false, false)
    }
  }
  const handlerClickRadioButton = (value: COMMUNITY_TYPE) => {
    sendDataHubConsume({
      entity: Entities.COMMUNITY,
      action: Actions.CREATE,
      event: {
        eventName: EventNames.SELECT_COMMUNITY_TYPE,
        screenName: ScreenNames.COMMUNITY_CREATION_MODAL,
        option: CommunityTypeProductConsume[value]
      }
    })

    setSelectedOption(value)
    setFormData('communityType', value)
    setCollaborativeContent(
      value,
      formData.collaborativeContent?.value,
      formData.collaborativeContent?.isSetByUser
    )
  }

  return (
    <div className='_d-flex _flex-column _mt-5'>
      <p className='_text-2 _text-gray-900 _font-weight _mb-1'>
        {t('configuration_sidebar.access_and_privacy.title')}
      </p>
      <Description className='_font-weight _text-gray-500 _mb-2'>
        {t('configuration_sidebar.access_and_privacy.description_create')}
      </Description>
      <ContainerAccessSection>
        {CommunitiesList.map((item) => {
          return (
            <AccessSection
              title={item.title}
              description={item.description}
              key={item.title}
              checked={item.type === selectedOption}
              disabled={false}
              value={item.type}
              page={PAGE_VIEW_ACCESS_SECTION.CREATE_COMMUNITY_MODAL}
              handleClickRadioButton={handlerClickRadioButton}
            />
          )
        })}
      </ContainerAccessSection>
    </div>
  )
}

export default AccessAndPrivacyCommunity
